/* eslint-disable unicorn/filename-case */
export function AnimatedDotsIcons(props?: { groupName?: string }) {
  const { groupName = 'group' } = props ?? {};
  // Escape forward slashes for CSS selector (e.g., group/dots-icon -> group\/dots-icon)
  const escapedGroupName = groupName.replace(/\//g, '\\/');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="animated-dots-icon"
    >
      <style>
        {`
            .animated-dots-icon .dot {
              transform-origin: center;
            }
            .${escapedGroupName}:hover .animated-dots-icon .dot-1 {
              animation: dotBounce 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
              animation-delay: 0ms;
            }
            .${escapedGroupName}:hover .animated-dots-icon .dot-2 {
              animation: dotBounce 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
              animation-delay: 70ms;
            }
            .${escapedGroupName}:hover .animated-dots-icon .dot-3 {
              animation: dotBounce 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
              animation-delay: 140ms;
            }
            @keyframes dotBounce {
              0% { transform: translateY(0); }
              40% { transform: translateY(-3px); }
              100% { transform: translateY(0); }
            }
          `}
      </style>
      <circle className="dot dot-1" cx="6" cy="12" r="1.5" />
      <circle className="dot dot-2" cx="12" cy="12" r="1.5" />
      <circle className="dot dot-3" cx="18" cy="12" r="1.5" />
    </svg>
  );
}
